// "DPJP belum terverifikasi" (Master Data): rows from GET /master/dpjp-belum-terverifikasi, one per typed name and
// Departemen, grouped per Departemen for display. No imports, so the Jest test runs without the "@/" alias.

export const SEMUA = "semua";
export const TANPA_DEPARTEMEN = "Tanpa departemen";
export const TANPA_KEY = "__tanpa__";      // group key for rows without ksm_id (a Select value cannot be "")

const byName = (a, b) => a.localeCompare(b, "id", { sensitivity: "base" });

// Most patients first, then the most recent submission, then the name, so the order never jumps between loads.
const byRow = (a, b) => (b.jumlah || 0) - (a.jumlah || 0)
  || String(b.terakhir || "").localeCompare(String(a.terakhir || ""))
  || byName(a.nama || "", b.nama || "");

// -> [{ key (ksm_id), ksm_nama, rows, nama, pasien }], Departemen A-Z with "Tanpa departemen" last.
export function groupByDepartemen(rows) {
  const groups = new Map();
  for (const r of rows) {
    const key = r.ksm_id || TANPA_KEY;
    if (!groups.has(key)) groups.set(key, { key, ksm_nama: (r.ksm_id && r.ksm_nama) || TANPA_DEPARTEMEN, rows: [] });
    groups.get(key).rows.push(r);
  }
  return [...groups.values()]
    .map((g) => ({ ...g, rows: [...g.rows].sort(byRow), nama: g.rows.length,
      pasien: g.rows.reduce((n, r) => n + (r.jumlah || 0), 0) }))
    .sort((a, b) => (a.key === TANPA_KEY) - (b.key === TANPA_KEY) || byName(a.ksm_nama, b.ksm_nama));
}

// Departemen filter: SEMUA, or one group key.
export function filterGroups(groups, key) {
  return key === SEMUA ? groups : groups.filter((g) => g.key === key);
}

// A filter on a Departemen that has nothing left (e.g. after Petakan) falls back to every Departemen.
export function validFilter(groups, key) {
  return key === SEMUA || groups.some((g) => g.key === key) ? key : SEMUA;
}

export const groupTitle = (g) => `${g.ksm_nama} (${g.nama} nama · ${g.pasien} pasien)`;
